import { Box, makeStyles, Typography } from '@material-ui/core';
import { WbCardContent } from '../../../WbCard';
import { WbNoData } from '../../../WbNoData';
import { WbChip } from '../../../WbTextField';
import { TextFieldValue } from '../../types';
import { useGeneralPurposePickerContext } from '../../GeneralPurposePickerContext';
import { WbButton } from '../../../WbButton';

const useStyles = makeStyles(
  theme => ({
    cardContent: {
      height: '100%',
      padding: '0px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    selected: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      overflow: 'auto',
      height: '100%',
    },
    aiGenerated: {
      border: 'solid 1px transparent',
      borderRadius: '4px',
      backgroundColor: `${theme.palette.bkg.accent} !important `,
      background:
        'linear-gradient( #ffffff, #ffffff) padding-box,linear-gradient(90deg, #EE72D3, #7C4DFF) border-box',
    },
  }),
  { name: 'SelectedEntitiesMultiPicker' },
);

export const SelectedEntities = ({
  entities,
  setEntities,
  selectableEntities,
}: {
  entities: TextFieldValue[];
  setEntities: (entities: TextFieldValue[]) => void;
  selectableEntities: number;
}) => {
  const classes = useStyles();
  const handleDelete = (indexToDelete: number) => () => {
    setEntities(entities.filter((_, index) => index !== indexToDelete));
  };

  const adaptLabel = (option: TextFieldValue) => {
    const labelKind = option?.kindDisplayName ?? option?.kind;
    return `${labelKind && selectableEntities > 1 ? `${labelKind}:` : ''} ${
      option?.label
    }`;
  };

  const { isAiGenerated } = useGeneralPurposePickerContext();

  const isAiHighlighted = (e: TextFieldValue) => {
    // TODO for now this works when the value is an object, extend this to work with all providers and supported return types
    return e.value && typeof e.value !== 'string' && isAiGenerated(e.value);
  };

  return (
    <WbCardContent className={classes.cardContent}>
      <Box display="flex" justifyContent="space-between" marginBottom="16px">
        <Typography variant="body1"> Your selection</Typography>
        <WbButton
          variant="outlined"
          size="small"
          color="primary"
          disabled={!entities?.length}
          onClick={() => setEntities([])}
          label="Clear all"
        />
      </Box>

      {!entities?.length ? (
        <WbNoData
          fillContainer
          header="You haven't made any selection yet."
          text="Select the entities you need from the list on the left."
        />
      ) : (
        <Box className={classes.selected}>
          {entities?.map((e: TextFieldValue, index: number) => (
            <WbChip
              key={e.label}
              label={adaptLabel(e)}
              onDelete={handleDelete(index)}
              style={{ width: 'fit-content' }}
              className={isAiHighlighted(e) ? classes.aiGenerated : ''}
            />
          ))}
        </Box>
      )}
    </WbCardContent>
  );
};
